module.exports = __webpack_public_path__ + "img/kitchen_full.1803acb3.jpg";